// extracted by mini-css-extract-plugin
export default {"outcomeContainer":"EmptyMarket_outcomeContainer--JLd","emptyMarketContainer":"EmptyMarket_emptyMarketContainer--yYt","table":"EmptyMarket_table--hym"};